import React, { useEffect } from 'react';
import './App.css';

function App() {
  useEffect(() => {
    document.title = 'General Accountability';
    // Set body background to ensure full coverage
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.height = '100vh';
    document.body.style.overflow = 'hidden';
    
    return () => {
      // Cleanup on unmount
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.height = '';
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="app">
      <div className="content">
        <h1 className="title">General Accountability</h1>
        <p className="subtitle">Every mushroom cloud starts with a handshake</p>
      </div>
    </div>
  );
}

export default App;